import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DisplayText, Form, FormLayout, Button, ButtonGroup, Card, Modal, Toast, InlineError, Headng, Banner } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import ProductDropdownSearch from '../ProductDropdownSearch';
import TransferFormItems from './components/TransferFormItems';
import FormPageActions from '@container/FormPageActions';
import DatePicker from '@presentational/DatePicker';

import { ta, tAttribute } from '@utils';

import { FieldArray } from 'formik';
import findIndex from 'lodash/findIndex';

const propTypes = {
  queryURL: PropTypes.string.isRequired,
  update: PropTypes.bool,
  completed: PropTypes.bool,
  isSeller: PropTypes.bool, // IF current user viewing form is Seller owner of the transfer.
  canShipItems: PropTypes.bool,
  errors: PropTypes.object,
  confirmModal: PropTypes.bool,
  openModal: PropTypes.func,
  sellerUserId: PropTypes.number,
};

const defaultProps = {
  confirmModal: false,
}

const nestedPTName = "products_transfers_attributes";

class TransferForm extends Component{
  constructor(props) {
    super(props);
    this.state = {
      confirmModal: props.confirmModal,
      formId: 0, // virtual formId to find when destroying (for new not saved items, for already saved items ID is enough)
    }
  }

  // Because onSelection comes from PolarisWrapper it cannot be accesed directly on Container.
  pushNewProduct = (_bla, dropdownItem) => {
    let { onSelection, values } = this.props;
    onSelection(nestedPTName, {
      // ...dropdownItem.record,
      // product_id: dropdownItem.record.shopify_id,
      variant: dropdownItem.record,
      quantity: 0,
      unit_cost: 0,
      shipped: 0,
      tax_rate: 13,
      variant_id: dropdownItem.record.id,
      formId: `F${this.state.formId}`, // to not clash with ID for already saved records
    });
    this.setState({ formId: this.state.formId + 1 })
  }

  toggleConfirmModal = () => {
    this.setState({confirmModal: !this.state.confirmModal})
  }

  modalSubmit = () => {
    if(this.state.confirmModal){ // To avoid double click duplicating submittion
      this.setState({confirmModal: false }, this.props.handleSubmit );
    }
  }

  handleItemRemoval = (searchId) => {// Add _destroy attribute
    console.log("SID", searchId);
    const itemIndex = this.props.values[nestedPTName].findIndex( (item) => (searchId == item.id) || (searchId == item.formId) );
    if(itemIndex != -1){
      const currentItem = this.props.values[nestedPTName][itemIndex]
      this.props.setFieldValue(`${nestedPTName}.${itemIndex}`, { ...currentItem, "_destroy": true });
    }
  }

  handleInvoiceDateChange = ({ start, end }) => {
    this.props.handleChange(start.toISOString(), "invoice_date"); 
  }

  render(){
    const props = this.props;
    let { handleChange, values, errors } = props;

    // cannot filter items directly or PolarisFormProvider confuses the form item names, _destroy ones are hidden on UI
    const transferItems = values[nestedPTName]

    return (
      <Form implicitSubmit={false} onSubmit={props.handleSubmit}>
        <Card title="Factura" sectioned>
          <FormLayout>
            <div>
              <div className="mt20">
                <div className="mb10">
                  <BasicTextField
                    name="invoice_number"
                    placeholder="Número de factura electrónica"
                    label={ tAttribute("transfer", "invoice_number") }
                    handleChange={ props.handleChange }
                    values={ props.values }
                    errors={ props.errors }
                  />
                </div>

                <div className="mv10">
                  <label className="d-block mb10">
                    { ta("transfer.invoice_date") }
                  </label>
                  <DatePicker
                    onChange={ this.handleInvoiceDateChange }
                    initialValues={{ start: props.values.invoice_date }}
                  />
                  { errors.invoice_date &&
                    <InlineError message={props.errors.invoice_date[0]} fieldID="invoice_date" />
                  }
                </div>
              </div>
            </div>
          </FormLayout>
        </Card>

        <Card title="Productos" sectioned>
          <div>
            { transferItems.length == 0 && props.errors && props.errors.base &&
              <Banner status="critical">
                { props.errors.base }
              </Banner>
            }
            <ProductDropdownSearch
              placeholder={ I18n.t("form.hint.transfer_product_search2") }
              queryURL={props.queryURL}
              onSelection={ this.pushNewProduct }
              sellerUserId={ props.sellerUserId }
            />
            <p className="mt10">
              { I18n.t("form.hint.transfer_product_search") }
            </p>

            { errors.products_transfers &&
              <InlineError message={props.errors.products_transfers[0]} fieldID="ProductTransfers" />
            }
          </div>
            {/* Headers for items */}
            <TransferFormItems
              formName={nestedPTName}
              items={ transferItems }
              currencySymbol={ props.values.currency_symbol }
              onChange={ props.handleChange }
              onRemove={ this.handleItemRemoval}

              errors={ props.errors }
            />
        </Card>

        <div className="flex justifyEnd mt20">
          <ButtonGroup>
            <Button
              loading={ props.loading }
              primary
              onClick={ this.toggleConfirmModal } >
              { props.update ? I18n.t("actions.update") : I18n.t("actions.create") }
            </Button>
          </ButtonGroup>
        </div>

        {/* TODO */}
        { props.deleteURL &&
          <FormPageActions
            loading={ props.loading }
            deleteURL={ props.deleteURL }
          />
        }

        <Modal
          open={this.state.confirmModal}
          onClose={this.toggleConfirmModal}
          title={I18n.t('app.messages.transfer_modal_title')}
          primaryAction={{
            content: I18n.t('actions.confirm'),
            onAction: this.modalSubmit,
            loading: props.loading,
            disabled: !this.state.confirmModal,
          }}
          secondaryActions={[
            {
              content: I18n.t('actions.cancel'),
              onAction: this.toggleConfirmModal,
            },
          ]}
        >
          <Modal.Section>
              <p>
                {I18n.t('app.messages.transfer_modal_content')}
              </p>
          </Modal.Section>
        </Modal>
      </Form>
    );
  }
}



TransferForm.propTypes = propTypes;
TransferForm.defaultProps = defaultProps;


export default TransferForm;
